// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"52e0e605","468":"708f2c1c","842":"8508866b"}[chunkId] + ".chunk.js";
};